import { EpisodesSortFieldType } from '@insights_module/types/Episode';
import { ShowSortFieldType, SortOrderType } from '@insights_module/types/Show';

export const PAGE_SIZE = 20 as number;
export const PAGE_FETCHING_OFFSET = 10 as number;

export const EPISODES_SORT_KEY = {
  PUBLISHED_DATE: 'published_date' as EpisodesSortFieldType,
  CREATED_AT: 'created_at' as EpisodesSortFieldType,
  DURATION: 'duration' as EpisodesSortFieldType,
  UPDATED_AT: 'updated_at' as EpisodesSortFieldType,
};
export const SHOWS_SORT_KEY = {
  NAME: 'name' as ShowSortFieldType,
  AUDIO_COUNT: 'audio_count' as ShowSortFieldType,
  CREATED_AT: 'created_at' as ShowSortFieldType,
  LATEST_EPISODE: 'most_recently_published_audio_date' as ShowSortFieldType,
};
export const SORT_ORDER = {
  ASC: 'asc' as SortOrderType,
  DESC: 'desc' as SortOrderType,
};
